import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Box, Typography, TextField, Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useState } from "react";
import API from "../../../api";
import { startToast, updateToastSuccess } from "../../../utils/notification-loading";

const VerifiedTable = ({ data }) => {

  const [open, setOpen] = useState(false);
  const [emailError, setEmailError] = useState('');
  const [vatError, setVatError] = useState('');
  const [selectedLecs, setSelectedLecs] = useState('');
  const [notes, setNotes] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [vat, setVat] = useState('');
  const [address, setAddress] = useState('');

  const handleActivate = (matricola) => {
    setSelectedLecs(matricola);
    setOpen(true);
  }

  const handleEmailChange = (e) => {
    const newEmail = e.target.value;
    setEmail(newEmail);
    const errorMessage = validateEmail(newEmail);
    setEmailError(errorMessage);
  };

  const handleVatChange = (e) => {
    const newVat = e.target.value;
    setVat(newVat);
    const errorMessage = validateVAT(newVat);
    setVatError(errorMessage);
  };

  const validateVAT = (vat) => {
    const vatRegex = /^[A-Za-z0-9]+$/; // Consente solo lettere e numeri
    if (!vatRegex.test(vat) && vat !== "") {
      return "Enter only alphanumeric characters.";
    }
    return "";
  };

  const validateEmail = (email) => {
    startToast();
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if (!emailRegex.test(email) && email !== "") {
      return "Enter a valid email address.";
    }
    return "";
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    API.activateLecs().then((response) => {
      updateToastSuccess("Lecs successfully entered");
    })
  }

  const columns = [
    {
      field: "matricola",
      headerName: "SERIAL NUMBER",
      minWidth: 110,
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "mac",
      headerName: "MAC ADDRESS",
      minWidth: 110,
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "dataProduzione",
      headerName: "PRODUCTION DATE (UTC +1)",
      minWidth: 160,
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      headerName: "ACTIVE LECS",
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        return (
          <Button
            onClick={() => handleActivate(params.row.matricola, params.row.mac)}
          >
            Activate
          </Button>
        )
      }
    },
  ]


  return (
    <>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        maxWidth="lg"
        PaperProps={{
          style: {
            width: '80%',
            backgroundColor: '#2a2a2a',
            borderRadius: 20,
            border: "solid, 3px #449095",
            backgroundImage: "none"
          }
        }}
      >
        <DialogTitle sx={{ fontSize: 50 }}>Activate Lecs {selectedLecs}</DialogTitle>
        <br />
        <DialogContent>
          <Box sx={{ display: "flex", gap: 5, alignItems: "start" }}>
            {/* Colonna sinistra */}
            <Box sx={{ flex: 1 }}>
              <Typography sx={{ fontSize: 30 }}>Insert Company Name</Typography>
              <TextField
                required
                label="Company Name"
                fullWidth
                value={name}
                onChange={e => setName(e.target.value)}
              />
              <br /><br />
              <Typography sx={{ fontSize: 30 }}>Insert Email</Typography>
              <TextField
                required
                label="Email"
                fullWidth
                value={email}
                onChange={handleEmailChange}
                error={!!emailError}
                helperText={emailError}
              />
              <br /><br />
              <Typography sx={{ fontSize: 30 }}>Insert VAT</Typography>
              <TextField
                required
                label="VAT"
                fullWidth
                value={vat}
                onChange={handleVatChange}
                error={!!vatError}
                helperText={vatError}
              />
              <br /><br />
              <Typography sx={{ fontSize: 30 }}>Insert Address</Typography>
              <TextField
                required
                label="Address"
                fullWidth
                value={address}
                onChange={e => setAddress(e.target.value)}
                error={!!vatError}
                helperText={vatError}
              />
            </Box>

            {/* Colonna destra per Notes */}
            <Box sx={{ flex: 1}}>
              <Typography sx={{ fontSize: 30 }}>Notes</Typography>
              <TextField
                label="Notes"
                fullWidth
                maxWidth="100%"
                multiline
                rows={15}
                value={notes}
                onChange={e => setNotes(e.target.value)}
              />
              <Box sx={{ display: 'flex', justifyContent: 'end', marginTop: 3 }}>
                <DialogActions>
                  <Button
                    onClick={e => handleSubmit(e)}
                    sx={{
                      backgroundColor: "#449095",
                      color: "white",
                      maxWidth: "15%",
                      fontSize: 15
                    }}>
                    ACTIVATE
                  </Button>
                </DialogActions>
              </Box>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>

      <Box
        height="93.5%"
      >
        <DataGrid
          sx={{
            fontWeight: 900,
            height: "100%",
            width: "100%",
            borderRadius: 5,
            border: "solid 1px #459095",
            overflowX: "auto",
            "& .MuiDataGrid-root": {
              border: "none",
              backgroundColor: "transparent !important"
            },
            "& .MuiDataGrid-cell": {
              borderBottom: "none",
            },
            "& .name-column--cell": {
              color: "#1D7B91",
              fontWeight: 900
            },
            "& .MuiDataGrid-toolbarContainer": {
              borderTopRightRadius: 17,
              borderTopLeftRadius: 17,
              gap: 4,
              backgroundColor: "#449095",
              color: "#1D7B91",
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "none",
              backgroundColor: "#449095",
              borderBottomLeftRadius: 20,
              borderBottomRightRadius: 20
            },
            "& .MuiCheckbox-root": {
              color: "#1D7B91 !important",
            },
            "& .MuiButtonBase-root": {
              color: "#fff !important",
            },
            "& .MuiCircularProgress-root": {
              color: "#5b9ba9 !important"
            },
            "& .MuiDataGrid-row:not(.MuiDataGrid-row--dynamicHeight) > .MuiDataGrid-cell": {
              whiteSpace: "normal !important"
            },
            "& .MuiBadge-badge": {
              backgroundColor: '#dd8d16'
            },
            "& .MuiDataGrid-root .MuiDataGrid-container--bottom [role=row]": {
              background: "#D0D0D0 !important"
            },
            "& .MuiDataGrid-panelWrapper": {
              width: '600px !important'
            },
            "& .MuiDataGrid-overlayWrapperInner": {
              backgroundColor: '#1a1a1a !important'
            },
            "& .MuiDataGrid-virtualScrollerContent": {
              backgroundColor: '#1a1a1a !important'
            },
            "& .MuiDataGrid-filler": {
              backgroundColor: '#1a1a1a !important'
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              fontWeight: 900
            },
            "& .MuiDataGrid-virtualScroller": {
              borderRadius: 0
            },
            "& .MuiDataGrid-columnHeader": {
              backgroundColor: "#449095",
            },
          }}
          hideFooter={true}
          rows={data ? data : []}
          columns={columns}
          slots={{ toolbar: GridToolbar }}
          slotProps={{
            toolbar: {
              printOptions: { disableToolbarButton: true },
            },
          }}
        />
      </Box>

    </>
  )
}

export default VerifiedTable